// extracted by mini-css-extract-plugin
export var row = "_vk-0";